export default __webpack_public_path__ + "static/media/slots-icon.991f4252.png";